<template>
    <BasicDrawer :duration="duration / 1000" ref="basicDrawerRef" v-if="show">
        <template v-slot:header>
            <div class="cancel-button" @click="closeDrawer">取消</div>

            <div class="header-title">
                <div class="title-label">自定义投放时长</div>
                <div class="title-tip">500元以上的订单建议投放6小时以上</div>
            </div>

            <div class="confirm-button" @click="confirm">确认</div>
        </template>

        <template>
            <div
                :class="['time-item', { 'is-check': item === currentTime }]"
                v-for="item in timeOptions"
                :key="item"
                @click="currentTime = item"
            >
                {{ item }}
            </div>
        </template>
    </BasicDrawer>
</template>

<script>
import BasicDrawer from "./BasicDrawer.vue";

export default {
    name: "TimeChangeDrawer",
    components: {
        BasicDrawer,
    },
    // props: ["show", "time"],
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        time: {
            type: String,
            required: true,
        },
        duration: {
            type: Number,
            default: 200,
        },
    },
    data() {
        return {
            timeOptions: ["2小时", "6小时", "12小时", "24小时"],
            currentTime: "",
        };
    },
    watch: {
        show(newVal) {
            if (newVal) {
                this.currentTime = this.time;
            }
        },
    },
    methods: {
        closeDrawer() {
            if (this.$refs.basicDrawerRef) {
                this.$refs.basicDrawerRef.hiddenDrawer();
            }

            setTimeout(() => {
                this.$emit("close");
            }, this.duration);
        },

        confirm() {
            this.$emit("confirm", this.currentTime);

            this.closeDrawer();
        },
    },
};
</script>

<style scoped lang="scss">
* {
    font-family: PingFang-SC;
}

::v-deep .drawer-box_header {
    font-size: 13px;
    color: #323233;
    font-weight: 600;

    .header-title {
        text-align: center;

        .title-tip {
            font-weight: 500;
            color: #999999;
            font-size: 12px;
            margin-top: 2px;
        }
    }

    .cancel-button,
    .confirm-button {
        cursor: pointer;
    }

    .confirm-button {
        color: #fc2b55;
    }
}

::v-deep .drawer-box_content {
    .time-item {
        width: 100%;
        border: 1px solid #f1f1f1;
        height: 30px;
        line-height: 30px;
        text-align: center;
        cursor: pointer;

        &:not(.time-item:first-of-type) {
            margin-top: 10px;
        }

        &.is-check {
            border-color: #fee3e8;
            background-color: #fff3f5;
            color: #fc2b55;
        }
    }
}
</style>
